import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Plural, Trans, withI18n } from 'lingui-react';
import { compose, setDisplayName } from 'recompose';
import { isEqual } from 'lodash';

import { Text, InputField } from 'base-components';
import { Row, Column } from 'styled-components-reactive-grid';

import useContext from 'utils/useContext';

import {
  containsCreditCardNumber,
  excludeCreditCardNumber,
  CreditCardComplianceModal,
} from 'utils/creditCardNumberCompliance';

import CaseRequestsPanelContext from '../CaseRequestsPanelContext';

const MAX_CHARACTERS = 1000;

export class SpecialInstructionsInputField extends Component {
  static propTypes = {
    i18n: PropTypes.shape({ t: PropTypes.func.isRequired }).isRequired,
    specialInstructions: PropTypes.string,
    updateSpecialInstructions: PropTypes.func.isRequired,
    readOnly: PropTypes.bool.isRequired,
  };

  static defaultProps = {
    specialInstructions: null,
  };

  state = {
    specialInstructions: this.props.specialInstructions,
    containsCreditCardNumber: false,
    ignoreCreditCardNumber: false,
  };

  shouldComponentUpdate({ specialInstructions, readOnly }, nextState) {
    return (
      specialInstructions !== this.props.specialInstructions ||
      readOnly !== this.props.readOnly ||
      !isEqual(nextState, this.state)
    );
  }

  handleChange = ({ target: { value } }) => {
    this.setState({ specialInstructions: value });
    this.props.updateSpecialInstructions(value);

    !this.state.ignoreCreditCardNumber &&
      containsCreditCardNumber(value) &&
      this.setState({ containsCreditCardNumber: true });
  };

  render() {
    const { i18n, readOnly } = this.props;
    const { specialInstructions } = this.state;

    return (
      <Fragment>
        <InputField
          maxLength={MAX_CHARACTERS}
          name="special-instructions-input"
          onChange={this.handleChange}
          placeholder={i18n.t`Enter note...`}
          value={specialInstructions}
          modifiers={['height_auto']}
          readOnly={readOnly}
        >
          <Column modifiers={['col', 'padScaleY_0']}>
            <Row>
              <InputField.Label>
                <Text modifiers={['small', 'textLight']}>
                  <Trans>Special Instructions (Optional)</Trans>
                </Text>
              </InputField.Label>
              <InputField.CharsLeftLabel>
                {charsLeft => (
                  <Plural
                    value={charsLeft}
                    one="# Character Left"
                    other="# Characters Left"
                  />
                )}
              </InputField.CharsLeftLabel>
            </Row>
            <Row>
              <InputField.TextArea rows={5} />
            </Row>
          </Column>
        </InputField>

        {this.state.containsCreditCardNumber && (
          <CreditCardComplianceModal
            onDeleteCreditCardNumber={() => {
              this.handleChange({
                target: { value: excludeCreditCardNumber(specialInstructions) },
              });
              this.setState({ containsCreditCardNumber: false });
            }}
            onContinue={() =>
              this.setState({
                containsCreditCardNumber: false,
                ignoreCreditCardNumber: true,
              })
            }
          />
        )}
      </Fragment>
    );
  }
}

export default compose(
  setDisplayName('SpecialInstructionsInputField'),
  withI18n(),
  useContext(CaseRequestsPanelContext),
)(SpecialInstructionsInputField);



// WEBPACK FOOTER //
// ./src/compositions/CaseRequestsPanel/SpecialInstructions/InputField.js